invHdApp.controller('MovementController', ['$scope', 'OrderMovement', '$location', '$filter', '$routeParams', '$rootScope', 'ngAudio',
	function ($scope, OrderMovement, $location, $filter, $routeParams, $rootScope, ngAudio) {

		var successSound = ngAudio.load("sounds/success.mp3");
		var errorSound = ngAudio.load("sounds/error.mp3");

		$scope.send = function () {
			OrderMovement.movement($scope.movement).success(function (data, status, headers, config) {
				$scope.movement.code = null
				$scope.orders = data.batch.orders;
				$scope.batch = data.batch;
				$scope.movement.force = false;
				Messenger().post(data.message);
				successSound.play()
			}).error(function (data) {
				errorSound.play()
				if (data.type && data.type === 'wrong_station') {
					$scope.errorMessage = data.message
					$('#wrongStation').modal('show');
					setTimeout(() => {
						document.getElementById("wrongStation").focus();
					}, 300);
				} else {
					Messenger().post({
						message: data.message,
						type: "error"
					});
				}

			});
		};

		$scope.continue = function () {
			$scope.movement.force = true;
			$('#wrongStation').modal('hide');
			$scope.send();
		}

		$scope.getBatch = function () {
			OrderMovement.getBatch($scope.movement).success(function (data, status, headers, config) {
				$scope.orders = data.batch.orders;
				$scope.batch = data.batch;
			}).error(function (data) {
				Messenger().post({
					message: data.message,
					type: "error"
				});
			});
		};

		$scope.print = function () {
			window.open('/print-batch/' + $scope.batch.id, '_blank').focus();
		};

		$scope.init = function () {
			OrderMovement.movementInit().success(function (data, status, headers, config) {
				$scope.data = data;
				$scope.movement = {
					type: '',
					code: null,
					station_id: null,
					weight: null
				}
				if ($routeParams.ids) {
					$scope.movement.code = $routeParams.ids;
				}
			});
		};
	}
]);